import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { EducationHostedFormSteps } from '../EducationHostedForm.types'

import { Alert, Checkbox, Flex, Typography } from '@percent/lemonade'
import { Step } from '@percent/education-hosted-form/ui/Step/Step'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'
import { useHandleValidationSubmission } from '@percent/education-hosted-form/hooks/useHandleValidationSubmission/useHandleValidationSubmission'
import { PRIVACY_POLICY_URL, TERMS_URL } from '@percent/education-hosted-form/constants/legalUrls'
import styles from './Terms.module.scss'

// Static — no state/prop dependency. Hoisted so the element identity is
// stable across renders (Trans still re-renders from context, this just
// avoids handing Checkbox a fresh label reference every time).
const checkboxLabel = (
  <Typography>
    <Trans
      i18nKey="terms.agreeTerms"
      components={{
        termsLink: (
          <a className={styles.link} target="_blank" href={TERMS_URL} rel="noopener noreferrer">
            _
          </a>
        ),
        privacyLink: (
          <a className={styles.link} target="_blank" href={PRIVACY_POLICY_URL} rel="noopener noreferrer">
            _
          </a>
        )
      }}
    />
  </Typography>
)

// No back button by design: DocumentUpload creates a BE record on submit, so
// letting the user step back would let them create duplicate document rows via
// re-upload. Browser back still works if someone genuinely needs to bail.
export function Terms() {
  const { t } = useTranslation()
  const { progress, mustReverifyCaptcha } = useEducationHostedForm()
  const { handleCreateValidationSubmission, isCreatingVS } = useHandleValidationSubmission()
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Step
      step={EducationHostedFormSteps.TERMS}
      title={t('terms.title')}
      description={t('terms.description')}
      onNext={handleCreateValidationSubmission}
      nextButtonDisabled={!isChecked}
      nextButtonLabel={t('button.submit')}
      progress={progress}
      isLoading={isCreatingVS}
    >
      <Flex direction="column" align="center" gap={16} w="100%" mt={16}>
        {mustReverifyCaptcha && <Alert variant="warning">{t('errorMessage.captchaFailed')}</Alert>}
        <Checkbox
          variant="default"
          active={isChecked}
          name="agreement"
          label={checkboxLabel}
          onChange={event => setIsChecked(event.currentTarget.checked)}
        />
      </Flex>
    </Step>
  )
}
